module.exports = __webpack_public_path__ + "img/bannerimg6.5675d729.png";